import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BannerSection from './BannerSection';
import HTMLFlipBook from 'react-pageflip';
import Company_Profile from './assets/Company_Profile.pdf';
import { AiOutlineDownload } from 'react-icons/ai';

const MinistryCertificate = () => {
  return (
    <>
      <Header />
      <BannerSection pageHeader="MINISTRY OF TOURISM" />
      <div className="blogContenT">
        <iframe
          src={`${process.env.PUBLIC_URL}/Ministry_of_Tourism_Certificate.pdf`}
          name="exam_frame"
        ></iframe>
      </div>

      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src={`${process.env.PUBLIC_URL}/Ministry_of_Tourism_Certificate.pdf`}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          allow="autoplay"
          className="flipBook"
        />
      </div>
      <Footer />
    </>
  );
};

export default MinistryCertificate;
